"use strict";

var _classCallCheck = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");

var whatwgEncoding = require("whatwg-encoding");

var parseContentType = require("content-type-parser");

var querystring = require("querystring");

var DOMException = require("../../web-idl/DOMException");

var EventTargetImpl = require("../events/EventTarget-impl").implementation;

var Blob = require("../generated/Blob");

var ProgressEvent = require("../generated/ProgressEvent");

var READY_STATES = Object.freeze({
  EMPTY: 0,
  LOADING: 1,
  DONE: 2
});

exports.implementation = /*#__PURE__*/function (_EventTargetImpl) {
  _inherits(FileReaderImpl, _EventTargetImpl);

  function FileReaderImpl(args, privateData) {
    var _this;

    _classCallCheck(this, FileReaderImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FileReaderImpl).call(this, [], privateData));
    _this.error = null;
    _this.readyState = READY_STATES.EMPTY;
    _this.result = null;
    _this.onloadstart = null;
    _this.onprogress = null;
    _this.onload = null;
    _this.onabort = null;
    _this.onerror = null;
    _this.onloadend = null;
    _this._ownerDocument = privateData.window.document;
    return _this;
  }

  _createClass(FileReaderImpl, [{
    key: "readAsArrayBuffer",
    value: function readAsArrayBuffer(file) {
      this._readFile(file, "buffer");
    }
  }, {
    key: "readAsDataURL",
    value: function readAsDataURL(file) {
      this._readFile(file, "dataURL");
    }
  }, {
    key: "readAsText",
    value: function readAsText(file, encoding) {
      this._readFile(file, "text", whatwgEncoding.labelToName(encoding) || "UTF-8");
    }
  }, {
    key: "abort",
    value: function abort() {
      if (this.readyState === READY_STATES.DONE || this.readyState === READY_STATES.EMPTY) {
        this.result = null;
        return;
      }

      if (this.readyState === READY_STATES.LOADING) {
        this.readyState = READY_STATES.DONE;
      }

      this._fireProgressEvent("abort");

      this._fireProgressEvent("loadend");
    }
  }, {
    key: "_fireProgressEvent",
    value: function _fireProgressEvent(name, props) {
      var event = ProgressEvent.createImpl([name, Object.assign({
        bubbles: false,
        cancelable: false
      }, props)], {});
      this.dispatchEvent(event);
    }
  }, {
    key: "_readFile",
    value: function _readFile(file, format, encoding) {
      var _this2 = this;

      if (!Blob.isImpl(file)) {
        throw new TypeError("file argument must be a Blob");
      }

      if (this.readyState === READY_STATES.LOADING) {
        throw new DOMException(DOMException.INVALID_STATE_ERR);
      }

      if (file.isClosed) {
        this.error = new DOMException(DOMException.INVALID_STATE_ERR);

        this._fireProgressEvent("error");
      }

      this.readyState = READY_STATES.LOADING;

      this._fireProgressEvent("loadstart");

      process.nextTick(function () {
        var data = file._buffer;

        if (!data) {
          data = new Buffer("");
        }

        _this2._fireProgressEvent("progress", {
          lengthComputable: !isNaN(file.size),
          total: file.size,
          loaded: data.length
        });

        process.nextTick(function () {
          switch (format) {
            default:
            case "buffer":
              {
                _this2.result = new Uint8Array(data).buffer;
                break;
              }

            case "dataURL":
              {
                var dataUrl = "data:";
                var contentType = parseContentType(file.type);

                if (contentType && contentType.isText()) {
                  var fallbackEncoding = whatwgEncoding.getBOMEncoding(data) || whatwgEncoding.labelToName(contentType.get("charset")) || "UTF-8";
                  var decoded = whatwgEncoding.decode(data, fallbackEncoding);
                  contentType.set("charset", encoding);
                  dataUrl += contentType.toString();
                  dataUrl += ",";
                  dataUrl += querystring.escape(decoded);
                } else {
                  if (contentType) {
                    dataUrl += contentType.toString();
                  }

                  dataUrl += ";base64,";
                  dataUrl += data.toString("base64");
                }

                _this2.result = dataUrl;
                break;
              }

            case "text":
              {
                _this2.result = whatwgEncoding.decode(data, encoding);
                break;
              }
          }

          _this2.readyState = READY_STATES.DONE;

          _this2._fireProgressEvent("load");

          _this2._fireProgressEvent("loadend");
        });
      });
    }
  }]);

  return FileReaderImpl;
}(EventTargetImpl);